import { Menu } from 'lucide-react';
import { SessionIndicators } from './SessionIndicators';
import { NotificationBell } from './NotificationBell';
import { ThemeToggle } from '@/components/ThemeToggle';
import { useEffect, useState } from 'react';

interface TopBarProps {
  onMobileMenu: () => void;
}

export function TopBar({ onMobileMenu }: TopBarProps) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const timeStr = now.toLocaleString('en-GB', {
    weekday: 'short', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    timeZone: 'UTC', hour12: false,
  }) + ' UTC';

  return (
    <header className="sticky top-0 z-20 h-16 bg-bg/85 backdrop-blur-xl border-b border-border/60">
      <div className="h-full px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-4">
        <button
          onClick={onMobileMenu}
          className="lg:hidden p-2 -ml-2 rounded-lg text-fg-muted hover:bg-bg-card"
          aria-label="Open menu"
        ><Menu className="size-5" /></button>
        <div className="flex-1" />
        <NotificationBell />
        {/* Theme toggle — separated by a divider */}
        <div className="flex items-center pl-1 pr-2 mr-1 border-r border-border/60">
          <ThemeToggle
            className="size-9"
            title="Toggle light / dark mode"
          />
        </div>
        <SessionIndicators />
        <span className="text-xs font-mono text-fg-muted tabular whitespace-nowrap min-w-[22ch] text-right ml-2 pl-2 border-l border-border/60">{timeStr}</span>
      </div>
    </header>
  );
}
